// Shared static content for the MTBL Management Consultancy website.

export const MTBL_LOGO =
  "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/b15egufr_MTBL%20GROUP%20UAE%20%20final%20LOGO_20260424_140444_0000.png";

export const MTBL_LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/b15egufr_MTBL%20GROUP%20UAE%20%20final%20LOGO_20260424_140444_0000.png";

export const CLIENT_LOGOS = [
  {
    name: "MPS Technologies",
    url: "https://customer-assets.emergentagent.com/job_a82dec77-410b-4d22-8ae4-0de2075f247e/artifacts/x4am5qex_MPS%20-%20Edited_20260420_120002_0000.png",
  },
  {
    name: "BZ LLC",
    url: "https://customer-assets.emergentagent.com/job_a82dec77-410b-4d22-8ae4-0de2075f247e/artifacts/bll17pv9_Screenshot_20250310_152506_ChatGPT%20-%20Edited_20260420_120031_0000.png",
  },
  {
    name: "First Choice Supplies",
    url: "https://customer-assets.emergentagent.com/job_a82dec77-410b-4d22-8ae4-0de2075f247e/artifacts/2hohr14t_123%20-%20Edited_20260420_115955_0000.png",
  },
  {
    name: "Black Knight Associates",
    url: "https://customer-assets.emergentagent.com/job_a82dec77-410b-4d22-8ae4-0de2075f247e/artifacts/1hbwye5w_Screenshot_20250308_225613_Write%20on%20PDF%20-%20Edited%20-%20Edited_20260420_120024_0000.png",
  },
  {
    name: "B7",
    url: "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/vcvhpb0e_1000593222_70ae52b6a0a0e3651583a58f2bd22633-12_25_2024%2C%2012_50_13%20PM%20-%20Edite_20260420_120035_0000.png",
  },
  {
    name: "JM Crown Holding",
    url: "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/rvimf52m_Screenshot_20251024_202341_Write%20on%20PDF%20-%20Edited_20260420_120043_0000.png",
  },
  {
    name: "Republic of Uganda",
    url: "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/8v0iyxh8_1000545738_724491ea2bbe05ca1b5ff0978cc8fa76-11_15_2024%2C%209_08_09%20AM%20-%20Edited_20260420_120103_0000.png",
  },
  {
    name: "Student Store It",
    url: "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/290jt6dy_Screenshot_20260422_204904_Gallery.jpg",
  },
];

export const IMAGES = {
  boardroom:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/09uot4sb_file_00000000a14871fda7a226c9b18285cd.png",
  skyline:
    "https://images.pexels.com/photos/24390617/pexels-photo-24390617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  energy:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/7znsmbvp_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_26_13%20PM.png",
  renewable:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/1xd6w8tz_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_32_00%20PM.png",
  telecom:
    "https://images.unsplash.com/photo-1557174360-3f4f7c724501?auto=format&fit=crop&w=1600&q=80",
  highway:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/pxragzf1_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_28_01%20PM.png",
  agriculture:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/5984unk1_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_35_20%20PM.png",
  oilgas:
    "https://images.unsplash.com/photo-1772376920749-afdc99c517f7?auto=format&fit=crop&w=1600&q=80",
  lodge:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/gz1o1wrz_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_29_22%20PM.png",
  navyAbstract:
    "https://images.pexels.com/photos/12306417/pexels-photo-12306417.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  drcResort:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/19c1hpfs_drc1.jpg",
  drcRiver:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/vvqn4csv_drc.jpg",
  sandton:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/ov3uyx69_sandton%20office.png",
  kololo:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/atrldsvf_kololo.png",
  dubai:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/xmncvc6z_Screenshot_20260424_132320_Maps%282%29%20%281%29.jpg",
  handshake:
    "https://customer-assets.emergentagent.com/job_mtbl-opportunities/artifacts/lvu7xrbq_handshake.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Sectors", to: "/sectors" },
  { label: "Opportunities", to: "/opportunities" },
  { label: "Impact", to: "/impact" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    title: "Strategic Advisory",
    body:
      "We provide advisory services to investors, institutions, and partners seeking to understand and access opportunities across emerging markets.",
  },
  {
    title: "Opportunity Positioning",
    body:
      "We support the structuring and positioning of opportunities to enhance visibility and investment readiness.",
  },
  {
    title: "Deal Engagement",
    body:
      "We engage in identifying and shaping opportunities across key sectors aligned with long-term value creation.",
  },
  {
    title: "Partnership Facilitation",
    body:
      "We connect stakeholders across government, the private sector, and investment ecosystems.",
  },
];

export const SECTORS = [
  {
    title: "Telecommunications",
    img: "telecom",
    body:
      "Positioning of backbone networks, tower infrastructure, and connectivity initiatives aligned with national digital-expansion priorities. We engage with operators, infrastructure funds, and public-sector stakeholders to identify and shape strategic opportunities across the connectivity value chain.",
  },
  {
    title: "Energy and Utilities",
    img: "energy",
    body:
      "Engagement across generation, transmission, and distribution — from conventional power assets to grid-modernisation programs. We work alongside institutional investors and development partners pursuing reliable, scalable energy opportunities across emerging markets.",
  },
  {
    title: "Renewable Energy",
    img: "renewable",
    body:
      "Advisory support for wind, solar, and hybrid renewable initiatives aligned with transition agendas and long-horizon institutional capital. We position opportunities for partners seeking disciplined entry into Africa's accelerating clean-energy buildout.",
  },
  {
    title: "Oil and Gas",
    img: "oilgas",
    body:
      "Opportunity positioning across upstream, midstream, and downstream value chains in resource-rich emerging markets. We engage selectively on assets and partnerships that combine commercial merit with credible execution pathways.",
  },
  {
    title: "Agriculture",
    img: "agriculture",
    body:
      "Engagement with agribusiness, value-chain, and food-security initiatives that contribute to economic participation and regional productivity — a cornerstone sector of long-term development across the continent.",
  },
  {
    title: "Tourism and Investment Promotion",
    img: "lodge",
    body:
      "Structured positioning of hospitality, conservation, and destination assets within regional investment agendas. We support operators, destination platforms, and public-sector partners building tourism into a durable growth engine.",
  },
  {
    title: "Infrastructure and Development",
    img: "highway",
    body:
      "Advisory engagement across transport, logistics, housing, and public-sector infrastructure programs. Our work supports the sourcing of strategic partners and investors for large-scale initiatives aligned with national development priorities.",
  },
];

export const OPPORTUNITIES = [
  {
    title: "Telecommunications Infrastructure",
    summary:
      "Positioning of backbone network, tower, and connectivity initiatives aligned with national digital expansion priorities.",
    img: "telecom",
  },
  {
    title: "Energy and Utilities Infrastructure",
    summary:
      "Engagement across generation, transmission, and distribution programs, including renewable and grid modernization opportunities.",
    img: "energy",
  },
  {
    title: "Tourism and Investment Positioning",
    summary:
      "Structured positioning of hospitality, conservation, and destination assets within regional investment agendas.",
    img: "lodge",
  },
  {
    title: "Infrastructure Development Initiatives",
    summary:
      "Advisory engagement across transport, logistics, housing, and public sector infrastructure programs.",
    img: "highway",
  },
];

export const WHY_MTBL = [
  "Rooted understanding of African markets",
  "Multi-sector engagement across growth industries",
  "Strong positioning of opportunities for investors and partners",
  "Engagement within established advisory and investment ecosystems",
  "Long-term focus on value creation and strategic alignment",
];

export const HIGHLIGHTS = [
  { k: "Established", v: "2012" },
  { k: "Engagement", v: "Multi-sector" },
  { k: "Exposure", v: "Infrastructure & Development" },
  { k: "Alignment", v: "National priorities" },
  { k: "Focus", v: "Partnership facilitation" },
];

export const INSIGHTS_ARTICLES = [
  {
    slug: "drc-uae-tourism-infrastructure-corridor",
    title:
      "DRC x UAE: Unlocking a New Tourism & Infrastructure Investment Corridor",
    category: "Tourism & Investment",
    date: "April 2026",
    excerpt:
      "A new investment corridor is quietly taking shape between Central Africa and the Middle East — with the DRC emerging as a high-potential tourism and infrastructure frontier backed by UAE interest.",
    img: "drcRiver",
    heroImg: "drcRiver",
    bodyImg: "drcResort",
    sections: [
      {
        kind: "paragraph",
        text:
          "A new investment corridor is quietly taking shape between Central Africa and the Middle East. At the center of it is the Democratic Republic of the Congo, now emerging as a high-potential tourism and infrastructure frontier backed by UAE interest.",
      },
      {
        kind: "paragraph",
        text:
          "The partnership between the Democratic Republic of the Congo and the United Arab Emirates reflects a broader global shift. Gulf nations are expanding aggressively into Africa, targeting high-growth, underdeveloped markets.",
      },
      {
        kind: "paragraph",
        text:
          "With rising demand for alternative investment destinations, Africa — particularly the DRC — is becoming a focal point for FDI, tourism expansion, and infrastructure development.",
      },
      {
        kind: "heading",
        text: "An underleveraged tourism market",
      },
      {
        kind: "paragraph",
        text:
          "The DRC presents one of the most underleveraged tourism markets globally:",
      },
      {
        kind: "list",
        items: [
          "World-class natural assets, including Virunga National Park",
          "Vast rainforests and biodiversity in the Congo Basin",
          "Urban hubs like Kinshasa with cultural and entertainment potential",
          "Minimal tourism infrastructure despite global appeal",
        ],
      },
      {
        kind: "paragraph",
        text: "This gap creates a first-mover advantage for investors.",
      },
      {
        kind: "image",
        src: "drcResort",
        caption:
          "Luxury eco-tourism lodges in rainforest settings — a model the DRC is uniquely positioned to scale.",
      },
      {
        kind: "heading",
        text: "What the UAE brings to the corridor",
      },
      {
        kind: "paragraph",
        text:
          "The UAE brings a proven model of transforming destinations into global tourism hubs:",
      },
      {
        kind: "list",
        items: [
          "Infrastructure development across aviation, hospitality, and logistics",
          "Global connectivity via hubs such as Dubai International Airport",
          "Access to sovereign wealth capital and private investors",
          "Expertise in luxury tourism and destination branding",
        ],
      },
      {
        kind: "heading",
        text: "The investment thesis",
      },
      {
        kind: "list",
        items: [
          "Development of luxury eco-tourism lodges and resorts",
          "Investment in airport, road, and hospitality infrastructure",
          "Creation of integrated tourism corridors",
          "Strategic destination branding and international positioning",
        ],
      },
      {
        kind: "paragraph",
        text:
          "Global investors are actively seeking untapped, high-return markets. With increasing competition in established destinations, the DRC offers a rare opportunity to enter early in a market with significant upside potential.",
      },
      {
        kind: "heading",
        text: "MTBL Management Consultancy's role",
      },
      {
        kind: "paragraph",
        text:
          "MTBL Management Consultancy is uniquely positioned to bridge this opportunity — connecting governments, investors, and strategic partners while driving branding, market entry, and project execution across emerging markets.",
      },
      {
        kind: "paragraph",
        text:
          "The DRC is no longer a hidden opportunity — it is becoming a strategic destination. Backed by UAE partnerships, it stands at the beginning of a transformative tourism and investment journey.",
      },
    ],
  },
  {
    title: "Africa Investment Trends: Positioning for the Next Decade",
    category: "Africa Investment Trends",
    date: "March 2026",
    excerpt:
      "A considered view on capital flows, sector readiness, and how institutional investors are approaching African markets in a shifting global context.",
    img: "skyline",
  },
  {
    title: "Emerging Markets Strategy: Beyond the Thematic Narrative",
    category: "Emerging Markets Strategy",
    date: "February 2026",
    excerpt:
      "Moving past broad thematic labels, we examine how disciplined opportunity positioning creates durable value in emerging markets.",
    img: "boardroom",
  },
  {
    title: "Telecommunications and Infrastructure: The Connective Tissue",
    category: "Telecommunications & Infrastructure",
    date: "January 2026",
    excerpt:
      "How connectivity infrastructure is shaping competitiveness, national development agendas, and cross-border investment priorities.",
    img: "telecom",
  },
  {
    title: "Energy and Development: Capital, Transition, and Reliability",
    category: "Energy & Development",
    date: "December 2025",
    excerpt:
      "Balancing transition ambitions with reliability needs — a framework for evaluating energy opportunities in growth markets.",
    img: "energy",
  },
  {
    title: "Tourism and Investment Positioning in Frontier Destinations",
    category: "Tourism & Investment",
    date: "November 2025",
    excerpt:
      "Structuring tourism assets and destination platforms to attract long-horizon institutional capital.",
    img: "lodge",
  },
  {
    title: "Agriculture, Value Chains, and Long-Term Partnerships",
    category: "Africa Investment Trends",
    date: "October 2025",
    excerpt:
      "Why agriculture remains a cornerstone of regional development — and where disciplined partnership models are emerging.",
    img: "agriculture",
  },
];

export const OFFICES = [
  {
    city: "Dubai, United Arab Emirates",
    address: "Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates",
    image: "dubai",
  },
  {
    city: "Johannesburg, South Africa",
    address: "5 Benmore, Sandton, Johannesburg 2196",
    image: "sandton",
  },
  {
    city: "Kampala, Uganda",
    address: "BMK House, Wampewo Road, PO Box 37468",
    image: "kololo",
  },
];

export const CONTACT_EMAIL = "info@mtblgroup.com";
